let clickOutside;
export default {
    bind: function (el, binding, vnode) {
        clickOutside = function (event) {
            if (!(el == event.target || el.contains(event.target))) {
                vnode.context[binding.expression](event);
            }
        };
        
        document.body.addEventListener('click', clickOutside)
    },
    unbind: function (el) {
        document.body.removeEventListener('click', clickOutside);
    },
    clickOutside:function(event){

    }
};
